export const EventsItems = [
  {
    id: 1,
    image: "./images-events/Eventos-Experienciales.webp",
    name: 'Eventos Experienciales',
    description: 'Creamos una estrategia a nivel empresarial que consiste en fidelizar a potenciales clientes y/o consumidores mediante la organización de eventos que canalicen las sensaciones, las experiencias de los asistentes y así desarrolle el reconocimiento de la marca.'
  },
  {
    id: 2,
    image: "./images-events/Eventos-de-Integracion.webp",
    name: 'Eventos de integración',
    description: 'El objetivo es  efectuar ejercicios de unión laboral que sean ludicas y dinámicas, capaces de reforzar y motivar los equipos de trabajo, con capacitaciones en espacios convenientes para que así formen parte de una misma familia empresarial.'
  },
  {
    id: 3,
    image: "./images-events/Eventos-de-Beneficiencia.webp",
    name: 'Eventos de Beneficencia',
    description: 'Nos gusta estar involucrados en la planeación y ejecución de este tipo de eventos en pro de las personas que necesitan alguna ayuda. Esta estrategia se ejecuta mediante la reunión de colaboradores que desarrollan diferentes actividades donde se generan donaciones voluntarias para un fin común.'  
  },
  {
    id: 4,
    image: "./images-events/Eventos-culturales-y-Recreativos.webp",
    name: 'Eventos culturales y/o Recreativos',
    description: 'Estos eventos tienen como finalidad difundir e incentivar el  esparcimiento de diferentes actividades que lograran crear vínculos emocionales con el público asistente. Estos pueden hacer referencia a las artes escénicas, musicales, fotografía, literatura, ferias, conciertos.'  
  },
  {
    id: 5,
    image: "./images-events/Eventos-Hibridos.webp",
    name: 'Eventos Híbridos',
    description: 'Hoy en día tienen ventajas claves por encima de los eventos tradicionales ya que la mayor diferencia es el alcance que ofrecen, los organizadores y audiencia ya no están sujetos a limitaciones físicas o geográficas; cualquier persona en el mundo, puede potencialmente participar en el evento.'  
  },
  {
    id: 6,
    image: "./images-events/Eventos-Fin-de-año.webp",
    name: 'Eventos Fin de año para su Marca o Empresa',
    description: 'La tendencia que se maneja en este momento es la de brindar experiencias que impacten positivamente al colaborador y a su familia. Por eso pensamos que es una oportunidad para que las Empresas motiven, reconozcan y  conecten con sus equipos de trabajo.'  
  },
  {
    id: 7,
    image: "./images-events/Desayunos-alumuerzos-Cenas.webp",
    name: 'Desayunos, Almuerzos, Refrigerios y/o Cenas para su empresa',
    description: 'Manejamos diferentes formatos para brindar una experiencia única que se acomode a tus necesidades y presupuestos. Contamos con una gran variedad de menús y presentaciones que cumplen con las normas de calidad y bioseguridad que el mercado exige.'  
  },
  {
    id: 8,
    image: "./images-events/Ferias-de-emprendimiento.webp",
    name: 'Ferias de emprendimiento',
    description: 'Creamos este tipo de eventos tanto presencial como híbrido, el cual permite el encuentro entre emprendedores, empresarios, inversores y organizaciones que buscan lograr acuerdos para abrir oportunidades de compra o venta de servicios y/o productos.'  
  },
  {
    id: 9,
    image: "./images-events/Lanzamiento-de-Producto.webp",
    name: 'Lanzamientos de Producto',
    description: 'Tiene como objetivo que la marca o el producto perdure en la mente de los asistentes antes durante y después del evento. Creamos una estrategia específica Y nos encargamos de organizarlo con todos los servicios requeridos, con la mejor planificación, comunicación y ejecución.'  
  },
  {
    id: 10,
    image: "./images-events/Aniversarios-de-Empresas.webp",
    name: 'Aniversarios de Empresas',
    description: 'Nos encargamos de planificar, organizar y ejecutar el aniversario de su empresa con total personalización para cada uno de nuestros clientes porque Sabemos lo importante que es para la empresa celebrar los años que lleva en pie, la trayectoria conseguida y de su crecimiento.'  
  },
  {
    id: 11,
    image: "./images-events/Seminarios-Congresos-simposios.webp",
    name: 'Seminarios, Congresos, Simposios y Foros',
    description: 'Es importante para una empresa generar jornadas  corporativas para formar a nuestros trabajadores de una forma mucho más interactiva, por eso a través de estos eventos creamos una detallada planificación con los recursos necesarios para su desarrollo.'
  },
  {
    id: 12,
    image: "./images-events/Coctel.webp",
    name: 'Coctel Empresarial',
    description: 'Sabemos que es un acontecimiento muy importante a celebrar o dar a conocer, por eso queremos que los asistentes experimenten la calidad de nuestros servicios como lo es, el catering, el personal y la producción audiovisual sin perder el objetivo de la creación del espacio planeado pora la empresa.'  
  },
  {
    id: 13,
    image: "./images-events/Eventos-Sociales.webp",
    name: 'Eventos Sociales',
    description: 'Nos encargamos de planificar y ejecutar eventos sociales que fortalezcan los lazos familiares, de amistad y comunidad a través de experiencias memorables. Ya sea una celebración íntima o una gran reunión, cuidamos cada detalle de la decoración, el montaje y la producción para que la ocasión se disfrute sin preocupaciones.'  
  },
]
